// Haptic feedback utility — wraps navigator.vibrate() with no-op fallback

const canVibrate = typeof navigator !== 'undefined' && 'vibrate' in navigator;

const vibrate = (pattern) => {
  if (canVibrate) {
    try { navigator.vibrate(pattern); } catch (_) { /* silent */ }
  }
};

const haptic = {
  light: () => vibrate(10),
  medium: () => vibrate(25),
  heavy: () => vibrate(50),
  success: () => vibrate([15, 50, 30]),
};

export default haptic;
